import { authHeader } from '../helpers';
import handleResponse from './handleResponse';
import { sourceFormConstants } from '_constants';

export const sourceFormService = {
    doAction,
    getAll,
    getById,
    _delete,
};


function doAction(sourceFormId, action, data = []) {
    return kick({
        'action': action,
        'sourceFormId': sourceFormId,
        'data' : data
    });
}

function kick(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch( process.env.REACT_APP_API_ENDPOINT + `/api/source-form-kick`, requestOptions).then(handleResponse);
}

function getAll(source_website_ids = [], text = '', page = '', per_page='')  {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_API_ENDPOINT + `/api/source-form?source_website_id=${source_website_ids.join()}&text=${text}&page=${page}&per_page=${per_page}`, requestOptions).then(handleResponse);
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_API_ENDPOINT + `/api/source-form/${id}`, requestOptions).then(handleResponse);
}

function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_API_ENDPOINT + `/api/source-form/${id}`, requestOptions).then(handleResponse);
}

